/**
 * Download string as file
 * @param {string} str - text to download
 * @param {string} filename - filename to download to
 * @param {string} mimetype - mimetype to download as
 */
export const downloadString = (str: string, filename: string, mimetype = 'data:text/plain;charset=utf-8'): void => {
  const parts: string[] = []
  // add UTF-8 BOM for text/csv when charset is utf-8
  if (
    /^(?:data:)?text\/csv(?:;|$)/i.test(mimetype) && // checks for data:text/csv or text/csv
    /charset=utf-8/i.test(mimetype) &&
    str.charCodeAt(0) !== 0xfeff // doesnt already have one
  ) {
    parts.push('\ufeff')
  }
  parts.push(str)

  const blob = new window.Blob(parts, { type: mimetype })
  const el = document.createElement('a')
  el.setAttribute('href', window.URL.createObjectURL(blob))
  el.setAttribute('download', filename)
  el.style.display = 'none'
  document.body.appendChild(el)
  el.click()
  document.body.removeChild(el)
}

export default downloadString
